import { createVanIconComponent } from "./van"

const New = createVanIconComponent("new")
export default New
